export default "__VITE_ASSET__CvUlK1Wx__"